// Per-test card colors, shared by every place that shows a test as a tile.

const cardBgClasses: Record<string, string> = {
    'osobnostny-dotaznik': 'bg-purple-50/70 dark:bg-purple-900/30',
    'big-five': 'bg-blue-50/70 dark:bg-blue-900/30',
    'moralny-vyvoj': 'bg-orange-50/70 dark:bg-orange-900/30',
    hodnoty: 'bg-indigo-50/70 dark:bg-indigo-900/30',
    'karierne-zaujmy': 'bg-green-50/70 dark:bg-green-900/30',
    motivacia: 'bg-red-50/70 dark:bg-red-900/30',
    'rastove-myslenie': 'bg-teal-50/70 dark:bg-teal-900/30',
    'charakterove-silne-stranky': 'bg-yellow-50/70 dark:bg-yellow-900/30',
    'dospely-vyvoj': 'bg-cyan-50/70 dark:bg-cyan-900/30',
    'vztahove-styly': 'bg-pink-50/70 dark:bg-pink-900/30',
    podnikavost: 'bg-amber-50/70 dark:bg-amber-900/30',
    'index-excelencie': 'bg-yellow-50/70 dark:bg-yellow-900/30',
    'chut-pomoct-slovensku': 'bg-sky-50/70 dark:bg-sky-900/30',
    'styly-vedenia': 'bg-purple-50/70 dark:bg-purple-900/30',
    'organizacne-paradigmy': 'bg-teal-50/70 dark:bg-teal-900/30',
    'urovne-vedomia': 'bg-indigo-50/70 dark:bg-indigo-900/30',
    'urovne-pocuvania': 'bg-sky-50/70 dark:bg-sky-900/30'
}

const cardAccentClasses: Record<string, string> = {
    'osobnostny-dotaznik': 'bg-purple-300 dark:bg-purple-900/30',
    'big-five': 'bg-blue-300 dark:bg-blue-900/30',
    'moralny-vyvoj': 'bg-orange-300 dark:bg-orange-900/30',
    hodnoty: 'bg-indigo-300',
    'karierne-zaujmy': 'bg-green-300 dark:bg-green-900/30',
    motivacia: 'bg-red-300 dark:bg-red-900/30',
    'rastove-myslenie': 'bg-teal-300',
    'charakterove-silne-stranky': 'bg-yellow-300 dark:bg-yellow-900/30',
    'dospely-vyvoj': 'bg-cyan-300',
    'vztahove-styly': 'bg-pink-300 dark:bg-pink-900/30',
    podnikavost: 'bg-amber-300',
    'index-excelencie': 'bg-yellow-300 dark:bg-yellow-900/30',
    'chut-pomoct-slovensku': 'bg-sky-300',
    'styly-vedenia': 'bg-purple-300 dark:bg-purple-900/30',
    'organizacne-paradigmy': 'bg-teal-300',
    'urovne-vedomia': 'bg-indigo-300',
    'urovne-pocuvania': 'bg-sky-300'
}

const cardTextClasses: Record<string, string> = {
    'osobnostny-dotaznik': 'text-purple-700 dark:text-purple-300',
    'big-five': 'text-blue-700 dark:text-blue-300',
    'moralny-vyvoj': 'text-orange-700 dark:text-orange-300',
    hodnoty: 'text-indigo-700 dark:text-indigo-300',
    'karierne-zaujmy': 'text-green-700 dark:text-green-300',
    motivacia: 'text-red-700 dark:text-red-300',
    'rastove-myslenie': 'text-teal-700 dark:text-teal-300',
    'charakterove-silne-stranky': 'text-yellow-700 dark:text-yellow-300',
    'dospely-vyvoj': 'text-cyan-700 dark:text-cyan-300',
    'vztahove-styly': 'text-pink-700 dark:text-pink-300',
    podnikavost: 'text-amber-700 dark:text-amber-300',
    'index-excelencie': 'text-yellow-700 dark:text-yellow-300',
    'chut-pomoct-slovensku': 'text-sky-700',
    'styly-vedenia': 'text-purple-700 dark:text-purple-300',
    'organizacne-paradigmy': 'text-teal-700 dark:text-teal-300',
    'urovne-vedomia': 'text-indigo-700 dark:text-indigo-300',
    'urovne-pocuvania': 'text-sky-700'
}

export const getCardBgClass = (slug: string) => cardBgClasses[slug] || 'bg-white dark:bg-surface-card'
export const getCardAccentClass = (slug: string) => cardAccentClasses[slug] || 'bg-gray-300 dark:bg-surface-subtle'
export const getCardTextClass = (slug: string) => cardTextClasses[slug] || 'text-gray-700 dark:text-txt-body'
